import "./styles.scss";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CLIENT_GET, CLIENT_PUT } from "../../../API/clientApi";

import { InputText } from "primereact/inputtext";
import { SideMenu } from "../../../components/SideMenu";

export function EditClient() {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = window.localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({
    name: "",
    active: 0,
  });

  useEffect(() => {
    async function getCLients() {
      setLoading(true);
      setError(null);

      const { url, options } = CLIENT_GET(id, token);

      const clientResponse = await fetch(url, options);
      const clientJson = await clientResponse.json();

      setData(clientJson.data);
      setLoading(false);
    }

    getCLients();
  }, [id, token]);

  function handleChange({ target }) {
    const { id, value } = target;
    setData({ ...data, [id]: value });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const { url, options } = CLIENT_PUT(
      id,
      {
        id: Number(id),
        name: data.name,
        active: Number(data.active),
      },
      token
    );

    try {
      setLoading(true);

      await fetch(url, options);

      setLoading(false);
      navigate("/client");
    } catch (err) {
      setError(
        "Houve um erro ao enviar os dados, contate o suporte ou tente mais tarde."
      );
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div>
        <SideMenu />
      </div>

      <div className="container fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <div>
                <i className="fas fa-building"></i>
                <h2>Cliente</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <h2>Editando Cliente</h2>
          {error ? <p>{error}</p> : ""}
          <form className="row" onSubmit={handleSubmit}>
            <div className="col-md-6 form-group">
              <label htmlFor="name">Nome</label>
              <InputText
                id="name"
                name="name"
                value={loading ? "Carregando.." : data.name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="profile">Status</label>
              <br />
              <select
                name="active"
                id="active"
                value={data.active}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value={1}>Ativo</option>
                <option value={0}>Inativo</option>
              </select>
            </div>

            <div className="col-md-12 buttonBox">
              <Link to="/client">
                <button className="cancel">Cancelar</button>
              </Link>
              {loading ? (
                <button type="submit" disabled className="register">
                  Editando...
                </button>
              ) : (
                <button type="submit" className="register">
                  Cadastrar
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
